<template>
    <span class="number-wrapper">
        <input :type="`${showSpin ? 'text' : 'number'}`"
               :class="`form__field form__field--number number-wrapper__number ${(def
                   ? `form__field--${def} js-${def} ${(showSpin ? 'number-wrapper__number--with-spin' : '')}`
                   : `${(showSpin ? 'number-wrapper__number--with-spin' : '')}` )}`"
               :name="def" :id="def" :ref="def"
               :placeholder="placeholder"
               :value="internalValue"
               :readonly="readOnly"
               :disabled="disabled"
               :min="minValue"
               @input="onInput"
               @keypress="restrictInputToNumbers"
               @change="onChange"
               @keydown="$emit('keydown', $event)"
               @keyup="$emit('keyup', $event)"
               @keyup.enter="$emit('keyup.enter', $event)"
               @mousedown="$emit('mousedown', $event)"
               @mouseover="$emit('mouseover', $event)"
               @mouseup="$emit('mouseup', $event)"
               @touchstart="$emit('touchstart', $event)"
               @touchend="$emit('touchend', $event)"
               @touchcancel="$emit('touchcancel', $event)">
        <div class="number-wrapper__buttons">
            <button v-if="showSpin"
                    class="number-wrapper__buttons__increment"
                    :disabled="disabled"
                    @click="onIncrement">+</button>
            <button v-if="showSpin"
                    class="number-wrapper__buttons__decrement"
                    :disabled="disabled"
                    @click="onDecrement">-</button>
        </div>
    </span>
</template>

<script>

import _ from 'lodash'

import keyquery from '@/helpers/keyquery'

import FormControlText from './form-control-text'

export default {

    props: {
        value: {
            type: Number,
            default: 0,
        },
        increment: {
            type: Number,
            default: 0,
        },
        allowDecimalPoint: {
            type: Boolean,
            default: false,
        },
        allowNegativeNumbers: {
            type: Boolean,
            default: false,
        },
    },

    mixins: [
        FormControlText,
    ],

    data() {
        return {
            allowances: [],
        }
    },

    computed: {

        showSpin() {
            return this.increment
        },

        minValue() {
            return this.allowNegativeNumbers ? '' : '0'
        },
    },

    mounted() {
        if (this.allowDecimalPoint) this.allowances.push('.')
        if (this.allowNegativeNumbers) this.allowances.push('-')
    },

    methods: {

        /**
         * Formats the output of event values. This can be overridden to format for specific control types.
         *
         * @param {any} value
         * @returns {?number} The formatted output according to the control.
         */
        formatEventOutput(value) {
            const noValue = value == null || value === '' || Number.isNaN(value)
            return noValue ? null : parseFloat(value).round(0)
        },

        onDecrement: _.debounce(function() {
            /* eslint-disable no-invalid-this */
            this.internalValue = parseFloat(this.value - this.increment).round(0)
            this.$emit('input', this.internalValue)
            /* eslint-enable no-invalid-this */
        }, 500),

        onIncrement: _.debounce(function() {
            /* eslint-disable no-invalid-this */
            this.internalValue = parseFloat(this.value + this.increment).round(0)
            this.$emit('input', this.internalValue)
            /* eslint-enable no-invalid-this */
        }, 500),

        restrictInputToNumbers(ev) {
            if (!keyquery.isNumber(ev.key) && !keyquery.isIn(ev.key, this.allowances))
                ev.preventDefault()
            else
                this.$emit('keypress', ev)
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.

.number-wrapper {
    position: relative;
    display: block;

    @include element('number') {

        @include modifier('with-spin') {
            display: inline-block;
            width: 85% !important;
        }
    }

    @include element('buttons') {
        display: inline-block;
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        width: 11%;

        @include elements('increment' 'decrement') {
            width: 1.5em;
            padding: 0;
            font-size: 0.7em;
            font-weight: bold
        }
    }
}

.form {

    @include element('field') {

        @include modifier('number') {
            @include read-only-field;
        }
    }
}

</style>
